<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix">
      <div id="main_area">
        <div class="information flex-container2">
          <div class="flex">
            <div class="item flex-1">
              <ul class="menu2">
                <li class="on">登入者：{{ loginInfo ? loginInfo.id : "" }}</li>
                <div id="two_column">
                  <dl>
                    <dd style="background-color: transparent">
                      <p>
                        上次登入時間：{{
                          grid ? grid.lastLoginDate : ""
                        }}　密碼效期:{{ grid ? grid.lastPwdTimeSpan : "" }}
                        天後需更新密碼
                      </p>
                    </dd>
                    <dd style="background-color: transparent">
                      <select v-model="form.govCode1" style="min-width: 200px">
                        <option
                          v-for="(item, index) in dropDownList.govCode"
                          :value="item.value"
                          :key="index"
                        >
                          {{ item.text }}
                        </option>
                      </select>
                      <input
                        type="submit"
                        class="btn"
                        value="切換機關"
                        v-show="loginInfo"
                        @click="btnChangeGovCode()"
                      />
                    </dd>
                  </dl>
                </div>
              </ul>
            </div>
            <div class="item flex-1">
              <ul class="menu2">
                <li class="on">內部公告</li>
                <div id="two_column">
                  <dl>
                    <dd
                      v-for="(data, index) in dropDownList.Notices"
                      :key="index"
                      @click="btnNoticeDetail(data)"
                      style="cursor: pointer"
                    >
                      <p class="date">{{ data.postDate }}</p>
                      <p optidx="0" class="description1 original">
                        {{ data.title }}
                      </p>
                    </dd>
                  </dl>
                </div>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PdisFooter />

    <Notice
      v-model="Notice.show"
      :title="Notice.grid.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="flex-container2">
          <div class="flex2">
            <div class="item2 p4">
              <!--  最新消息-->
              <div class="table_scroll2">
                <div id="two_column">
                  <dl>
                    <h3>公告日期：</h3>
                    <dd>
                      <p class="txt_01">
                        {{ Notice.grid.postDate }}
                      </p>
                    </dd>
                    <h3>標題：</h3>
                    <dd>
                      <p class="txt_01">{{ Notice.grid.title }}</p>
                    </dd>
                    <h3>內容：</h3>
                    <dd>
                      <p v-html="Notice.grid.content"></p>
                    </dd>
                    <h3>附件檔案：</h3>
                    <dd v-for="(data, index) in Notice.grid.file" :key="index">
                      <a
                        :href="
                          data.attR_STRING
                            ? 'data:' + data.attR_TYPE + ';base64,' + data.attR_STRING
                            : '#'
                        "
                        :download="data.attR_NAME"
                      >
                        {{ data.attR_NAME }}<
                      </a>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Notice>

    <Alert v-model="Alert.show" :title="Alert.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import PdisFooter from "@/components/Common/PdisFooter.vue";
import {
  SearchGovCode,
  GetNotice,
  GetNoticeDetail,
  Index_SearchGrid,
  BackstageApiLogin,
} from "@/service/api.js";
export default {
  name: "P102",
  data: function () {
    return {
      pageData: {
        MenuIndex: 0,
        ServiceUnit: "PDIS",
        isForceLoginOut: true,
      },
      loginInfo: sessionStorage.getItem("LoginInfo")
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      dropDownList: {
        govCode: [],
        Notices: [],
        govCode1s: [],
        govCode2s: [],
        govCode3s: [],
        govCode4s: [],
      },
      form: {
        govCode1: sessionStorage.getItem("Session_GovCode") ? sessionStorage.getItem("Session_GovCode")
          : sessionStorage.getItem("LoginInfo") ? (JSON.parse(sessionStorage.getItem("LoginInfo")).govCodeStr.split(",")[3] != "" 
          ?  JSON.parse(sessionStorage.getItem("LoginInfo")).govCodeStr.split(",")[3]
          : JSON.parse(sessionStorage.getItem("LoginInfo")).govCodeStr.split(",")[2] != "" 
          ? JSON.parse(sessionStorage.getItem("LoginInfo")).govCodeStr.split(",")[2]
          : JSON.parse(sessionStorage.getItem("LoginInfo")).govCodeStr.split(",")[1] != "" 
          ? JSON.parse(sessionStorage.getItem("LoginInfo")).govCodeStr.split(",")[1]
          : JSON.parse(sessionStorage.getItem("LoginInfo")).govCodeStr.split(",")[0] != "" 
          ? JSON.parse(sessionStorage.getItem("LoginInfo")).govCodeStr.split(",")[0]
          : "") : "",
      },
      grid: {},
      Notice: {
        show: false,
        title: "",
        grid: [],
      },
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    PdisFooter,
    Notice: VueModal,
    Alert: VueModal,
  },
  methods: {
    //取得服務機關第一層類別
    getSearchGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode1s = rData.returnObject;
        let GovCode2 = { UP_GOV_CODE: "", LAYER_NUM: "2", GOV_CODE: "" };
        SearchGovCode(GovCode2).then((rData) => {
          self.dropDownList.govCode2s = rData.returnObject;
          let GovCode3 = { UP_GOV_CODE: "", LAYER_NUM: "3", GOV_CODE: "" };
          SearchGovCode(GovCode3).then((rData) => {
            self.dropDownList.govCode3s = rData.returnObject;
            let GovCode4 = { UP_GOV_CODE: "", LAYER_NUM: "4", GOV_CODE: "" };
            SearchGovCode(GovCode4).then((rData) => {
              self.dropDownList.govCode4s = rData.returnObject;
              var govcodeList = [];
              var dropDownList = [];
              for (let i = 0; i < self.loginInfo.govCodeStrList.length; i++) {
                if (self.loginInfo.govCodeStrList[i].split(",")[3] != "") {
                  govcodeList.push(
                    self.loginInfo.govCodeStrList[i].split(",")[3]
                  );
                  var a = self.dropDownList.govCode4s.filter(function (item) {
                    return item.value === govcodeList[i];
                  })[0];
                  dropDownList.push(a);
                } else if (
                  self.loginInfo.govCodeStrList[i].split(",")[2] != ""
                ) {
                  govcodeList.push(
                    self.loginInfo.govCodeStrList[i].split(",")[2]
                  );
                  var a = self.dropDownList.govCode3s.filter(function (item) {
                    return item.value === govcodeList[i];
                  })[0];
                  dropDownList.push(a);
                } else if (
                  self.loginInfo.govCodeStrList[i].split(",")[1] != ""
                ) {
                  govcodeList.push(
                    self.loginInfo.govCodeStrList[i].split(",")[1]
                  );
                  var a = self.dropDownList.govCode2s.filter(function (item) {
                    return item.value === govcodeList[i];
                  })[0];
                  dropDownList.push(a);
                } else {
                  govcodeList.push(
                    self.loginInfo.govCodeStrList[i].split(",")[0]
                  );
                  var a = self.dropDownList.govCode1s.filter(function (item) {
                    return item.value === govcodeList[i];
                  })[0];
                  dropDownList.push(a);
                }
              }

              if (self.loginInfo.roleSeq == 1 || self.loginInfo.roleSeq == 32) {
                self.dropDownList.govCode = self.dropDownList.govCode1s;
              } else {
                self.dropDownList.govCode = dropDownList;
              }
            });
          });
        });
      });
    },
    //取得公告
    getNoticeData: function () {
      const self = this;
      let postData = {
        serviceUnit: self.pageData.ServiceUnit,
        postNode: "2",
      };
      GetNotice(postData).then((returnData) => {
        self.dropDownList.Notices = returnData.returnObject.notices;
        self.dropDownList.Notices.forEach(
          (x) => (x.postDate = self.$moment(x.posT_DATE).format("YYYY/MM/DD"))
        );
      });
    },
    btnNoticeDetail: function (data) {
      const self = this;
      let postData = {
        serviceUnit: self.pageData.ServiceUnit,
        postSeq: data.posT_SEQ,
      };
      GetNoticeDetail(postData).then((returnData) => {
        self.Notice.grid = returnData.returnObject.noticeDetails[0];
        self.Notice.grid.postDate = self
          .$moment(self.Notice.grid.posT_DATE)
          .format("YYYY/MM/DD HH:mm:ss");
        self.Notice.show = true;
      });
    },
    btnChangeGovCode: function () {
      const self = this;
      sessionStorage.removeItem("Session_GovCode");
      if (self.loginInfo.roleSeq == 1 || self.loginInfo.roleSeq == 32) {
        sessionStorage.setItem("Session_GovCode", self.form.govCode1);
        self.Alert.show = true;
        self.Alert.title = "訊息";
        self.Alert.txt = ["切換成功!"];
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
      } else {
        let postData = {
          serviceUnit: "PDIS",
          id: self.loginInfo.id,
          changeGovCode: self.form.govCode1,
        };
        BackstageApiLogin(postData).then((rData) => {
          if (rData.result) {
            sessionStorage.setItem(
              "LoginInfo",
              JSON.stringify(rData.returnObject[0])
            );
            sessionStorage.removeItem("Session_GovCode");
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = ["切換成功!"];
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          } else {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = ["切換失敗!"];
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          }
        });
      }
    },
    getIndex: function () {
      const self = this;
      let postData = {
        ServiceUnit: self.pageData.ServiceUnit,
        id: self.loginInfo ? self.loginInfo.id : "",
        rolE_SEQ: self.loginInfo
          ? self.loginInfo.roleSeq
            ? self.loginInfo.roleSeq
            : 0
          : 0,
      };
      Index_SearchGrid(postData).then((rData) => {
        self.grid = rData.returnObject;
        // sessionStorage.setItem("RoleAuthorizeMenu", JSON.stringify(self.grid.roleAuthorizeMenu));
      });
    },
    //取得受理申報機關第一層類別
    getSearchJobGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode1s = rData.returnObject;
        let GovCode2 = { UP_GOV_CODE: "", LAYER_NUM: "2", GOV_CODE: "" };
        SearchGovCode(GovCode2).then((rData) => {
          self.dropDownList.govCode2s = rData.returnObject;
          let GovCode3 = { UP_GOV_CODE: "", LAYER_NUM: "3", GOV_CODE: "" };
          SearchGovCode(GovCode3).then((rData) => {
            self.dropDownList.govCode3s = rData.returnObject;
            let GovCode4 = { UP_GOV_CODE: "", LAYER_NUM: "4", GOV_CODE: "" };
            SearchGovCode(GovCode4).then((rData) => {
              self.dropDownList.govCode4s = rData.returnObject;
            });
          });
        });
      });
    },
  },
  created() {
    this.getSearchGovCode1();
    this.getNoticeData();
    this.getIndex();
  },
};
</script>

<style scoped src="@/assets/css/Pdis.css" />

